import PropTypes from 'prop-types';

import { themes } from '../../../lib/themes';

import styles from './styles.module.scss';

const Search = ({ theme, className, style, onClick }) => (
  <svg
    role="img"
    viewBox="0 0 16 16"
    className={className}
    onClick={onClick}
    style={style}
  >
    <title>Magnifying glass</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-339.000000, -632.000000)"
        className={styles[theme]}
      >
        <g transform="translate(0.000000, 613.000000)">
          <path d="M340.279987,25.399936 C340.279987,22.5769242 342.576924,20.2799872 345.399936,20.2799872 C348.222948,20.2799872 350.519885,22.5769242 350.519885,25.399936 C350.519885,28.2229478 348.222948,30.5198848 345.399936,30.5198848 C342.576924,30.5198848 340.279987,28.2229478 340.279987,25.399936 M354.812322,33.9073709 L350.354766,29.4498155 L350.354766,29.4491755 L351.282757,30.3778062 C351.02868,30.1230888 350.500685,29.2936571 351.084999,28.3701463 L351.060039,28.3842262 C351.530435,27.4927151 351.799872,26.4783252 351.799872,25.399936 C351.799872,21.8652513 348.934621,19 345.399936,19 C341.865251,19 339,21.8652513 339,25.399936 C339,28.9346207 341.865251,31.799872 345.399936,31.799872 C346.478965,31.799872 347.492715,31.5304347 348.383586,31.0593994 L348.370146,31.0849992 C349.293657,30.500685 350.123729,31.0280397 350.377806,31.2827572 L349.449176,30.3547665 L349.449816,30.3547665 L353.907371,34.8123219 C354.03217,34.9371206 354.196008,34.99984 354.359846,34.99984 C354.523685,34.99984 354.687523,34.9371206 354.812322,34.8123219 C355.062559,34.5620844 355.062559,34.1576084 354.812322,33.9073709" />
        </g>
      </g>
    </g>
  </svg>
);

Search.propTypes = {
  theme: PropTypes.oneOf(themes),
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

Search.defaultProps = {
  theme: 'waybetter',
};

export default Search;
